module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing2.3c4e960ac0025bf55fdcd16328978e77.png";